export const endpoints = {
  retrieve: landingPageSlug => `/commons/landing-pages/${landingPageSlug}/`,
};
